{
  "pt": {
    "issue_status": {
      "actions": {
        "create": "Criar status de reclamação"
      },
      "labels": {
        "backup_status": "Estado de substituição",
        "customer_status": "O cliente verá",
        "delete_status": "Eliminar estado \"{name}\"?",
        "delete_status_disclaimer": "Todos os itens de assistência com este estado serão reatribuídos ao estado que selecionar abaixo.",
        "inbox_hint": "Estado padrão para a caixa de entrada do cliente",
        "internal_status": "Estado interno",
        "new_issue_status": "Estado"
      }
    }
  }
}